import React from 'react';
import { Switch, Route } from 'react-router-dom';

import RedefinirSenha from '../Pages/RedefinirSenha';
import Login from '../Pages/Login';

const AuthRoutes: React.FC = () => (
  <Switch>
    <Route path="/resetar-senha" exact component={RedefinirSenha} />
    <Route path="/" component={Login} />
  </Switch>
);

export default AuthRoutes;
